<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div style="text-align: left">
        {{ user.email }}
      </div>
      <div style="text-align: right">
        {{ user.sessionLogs.length }}
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card>
        <v-card-title>
          <v-btn text normal color="#FF3401" @click="csvExport()">
            Export Selected
          </v-btn>
          <v-btn text normal color="#FF3401" @click="exportAll(user.email)">
            Export All
          </v-btn>
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          />
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="indexedItems"
          :search="search"
          v-model="selected"
          item-key="id"
          show-select
        />
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>

import axios from 'axios';
import millisToMinutesAndSeconds from '../utils';

export default {
  data() {
    return {
      search: '',
      singleSelect: false,
      selected: [],
      headers: [
        { text: 'App Start Time', value: 'appStartTimeDate' },
        { text: 'App Duration M:S', value: 'duration' },
        { text: 'Machine Start Hours', value: 'machineStartHoursMeter' },
        { text: 'Machine End Hours', value: 'machineEndHoursMeter' },
        { text: 'Machine Serial Number', value: 'machineSerialNumber' },
        { text: 'Hardware Serial Number', value: 'hardwareSerialNumber' },
        { text: 'Hardware Version', value: 'hardwareVersion' },
        { text: 'Firmware Version', value: 'firmwareVersion' },
        { text: 'Device', value: 'device' },
      ],
    };
  },
  props: ['user'],
  computed: {
    indexedItems() {
      return this.user.sessionLogs.map((item, index) => ({
        id: index,
        location: `${item.sessionStartLocationLat}, ${item.sessionStartLocationLng}`,
        duration: millisToMinutesAndSeconds(Date.parse(item.endTime) - Date.parse(item.startTime)),
        appStartTimeDate: new Date(item.startTime).toDateString(),
        ...item,
      }));
    },
  },
  methods: {
    exportAll(uuid) {
      axios.get(`${process.env.VUE_APP_BACKEND_URL}/export/user/${uuid}`, { headers: { Authorization: localStorage.token } })
        .then((response) => {
          if (response.data.length !== 0) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'export.csv');
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    csvExport() {
      let csvContent = 'data:text/csv;charset=utf-8,';
      csvContent += [
        Object.keys(this.selected[0]).join(','),
        ...this.selected.map((item) => Object.values(this.formatDates(item)).join(',')),
      ]
        .join('\n')
        .replace(/(^\[)|(]$)/gm, '');

      const data = encodeURI(csvContent);
      const link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', 'export.csv');
      link.click();
    },
    formatDates(item) {
      const formatted = item;
      formatted.engineEndTime = item.engineEndTime.replace('T', ' ').replace('Z', '');
      formatted.engineStartTime = item.engineEndTime.replace('T', ' ').replace('Z', '');
      formatted.endTime = item.engineEndTime.replace('T', ' ').replace('Z', '');
      formatted.startTime = item.engineEndTime.replace('T', ' ').replace('Z', '');
      return formatted;
    },
  },
};
</script>

<style scoped>

</style>
